import { useState } from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { girlsClothingProducts } from '../../mocks/products';
import { Link } from 'react-router-dom';

const ClothingPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [priceRange, setPriceRange] = useState('All');

  const categories = ['All', 'Embroidered', 'Plain', 'With Scarf'];
  const priceRanges = ['All', 'Under $50', '$50-$60', 'Over $60'];

  // Filter only Abayas
  const abayaProducts = girlsClothingProducts.filter(p => p.category === 'Abayas');

  const filteredProducts = abayaProducts.filter(product => {
    let categoryMatch = true;
    if (selectedCategory === 'Embroidered') {
      categoryMatch = product.name.toLowerCase().includes('embroid');
    } else if (selectedCategory === 'Plain') {
      categoryMatch = !product.name.toLowerCase().includes('embroid');
    } else if (selectedCategory === 'With Scarf') {
      categoryMatch = product.name.toLowerCase().includes('scarf');
    }
    
    let priceMatch = true;
    if (priceRange === 'Under $50') {
      priceMatch = product.price < 50;
    } else if (priceRange === '$50-$60') {
      priceMatch = product.price >= 50 && product.price <= 60;
    } else if (priceRange === 'Over $60') {
      priceMatch = product.price > 60;
    }
    
    return categoryMatch && priceMatch;
  });

  return (
    <div className="min-h-screen bg-cream-100">
      <Header />
      
      {/* Hero Section - Faceless Abaya Photography */}
      <section className="relative py-24 bg-gradient-to-br from-emerald-800 via-emerald-700 to-emerald-600 overflow-hidden">
        {/* Background Image - Faceless Abaya Back View */}
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/7fdb5e9bda10c27e8083d09553092842.jpg"
            alt="Signature Abayas"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/70 via-emerald-800/60 to-emerald-900/70"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center text-white max-w-4xl mx-auto">
            {/* Decorative Top Divider */}
            <div className="flex items-center justify-center mb-6">
              <div className="h-px w-16 bg-gold-400"></div>
              <div className="w-2 h-2 bg-gold-400 rounded-full mx-3"></div>
              <div className="h-px w-16 bg-gold-400"></div>
            </div>
            
            <h1 className="text-6xl font-bold mb-6 text-cream-100" style={{ fontFamily: '"Playfair Display", serif' }}>
              Signature Abayas
            </h1>
            <p className="text-xl text-cream-100 leading-relaxed max-w-2xl mx-auto mb-6">
              Handcrafted with love, embroidered with tradition. Each abaya tells a story of elegance, modesty, and cultural pride.
            </p>
            
            {/* Decorative Bottom Divider */}
            <div className="flex items-center justify-center">
              <div className="h-px w-16 bg-gold-400"></div>
              <div className="w-2 h-2 bg-gold-400 rounded-full mx-3"></div>
              <div className="h-px w-16 bg-gold-400"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Filters Section */}
      <section className="py-8 bg-white border-b border-cream-300 sticky top-20 z-40 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row gap-6 items-center justify-between">
            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 items-center">
              <span className="text-sm font-semibold text-emerald-800 mr-2">Style:</span>
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer border-2 ${
                    selectedCategory === category
                      ? 'bg-emerald-600 text-white border-emerald-600 shadow-md'
                      : 'bg-white text-emerald-700 border-emerald-200 hover:border-emerald-400 hover:bg-emerald-50'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Price Filter */}
            <div className="flex flex-wrap gap-2 items-center">
              <span className="text-sm font-semibold text-emerald-800 mr-2">Price:</span>
              {priceRanges.map(range => (
                <button
                  key={range}
                  onClick={() => setPriceRange(range)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer border-2 ${
                    priceRange === range
                      ? 'bg-gold-500 text-white border-gold-500 shadow-md'
                      : 'bg-white text-gold-600 border-gold-200 hover:border-gold-400 hover:bg-gold-50'
                  }`}
                >
                  {range}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="mb-8 flex items-center justify-between">
            <p className="text-emerald-800 font-medium">
              Showing {filteredProducts.length} {filteredProducts.length === 1 ? 'abaya' : 'abayas'}
            </p>
            <div className="flex items-center space-x-2 text-sm text-emerald-700">
              <div className="w-3 h-3 bg-gold-500 rounded-full"></div>
              <span className="font-medium">Ready to Ship</span>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
            {filteredProducts.map((product) => (
              <Link key={product.id} to={`/product/${product.id}`}>
                <div className="group cursor-pointer">
                  <div className="bg-cream-50 rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border-2 border-transparent hover:border-gold-400">
                    <div className="relative">
                      <div className="w-full h-96 bg-white">
                        <img 
                          src={product.image}
                          alt={product.name}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      
                      {/* Ready to Ship Badge */}
                      {product.inStock && (
                        <div className="absolute top-4 left-4 bg-gold-500 text-white px-3 py-1.5 rounded-full text-xs font-bold shadow-lg flex items-center space-x-1">
                          <div className="w-2 h-2 bg-white rounded-full"></div>
                          <span>Ready to Ship</span>
                        </div>
                      )}
                      
                      {/* Wishlist Button */}
                      <div className="absolute top-4 right-4">
                        <button className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-colors cursor-pointer">
                          <i className="ri-heart-line text-emerald-700 text-lg"></i>
                        </button>
                      </div>
                    </div>
                    
                    <div className="p-5">
                      <h3 className="text-base font-bold text-emerald-900 mb-3 line-clamp-2 leading-snug" style={{ fontFamily: '"Lora", serif' }}>
                        {product.name}
                      </h3>
                      
                      {/* Size Info */}
                      {product.sizes && product.sizes.length > 0 && (
                        <div className="flex items-center space-x-2 mb-3">
                          <span className="text-xs text-emerald-700 font-medium">Size:</span>
                          <span className="text-xs text-gray-600">{product.sizes.join(', ')}</span>
                        </div>
                      )}
                      
                      {/* Rating */}
                      <div className="flex items-center mb-3">
                        <div className="flex text-gold-500 text-sm">
                          {[...Array(5)].map((_, i) => (
                            <i key={i} className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'}`}></i>
                          ))}
                        </div>
                        <span className="text-xs text-gray-500 ml-2">({product.reviews})</span>
                      </div>
                      
                      {/* Price and CTA */}
                      <div className="flex items-center justify-between pt-3 border-t border-cream-200">
                        <div className="flex items-baseline space-x-2">
                          <span className="text-2xl font-bold text-emerald-800">${product.price}</span>
                          {product.originalPrice > product.price && (
                            <span className="text-sm text-gray-400 line-through">${product.originalPrice}</span>
                          )}
                        </div>
                        <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-md">
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="text-center py-20">
              <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6 text-emerald-200">
                <i className="ri-shopping-bag-line text-7xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-emerald-900 mb-3" style={{ fontFamily: '"Playfair Display", serif' }}>
                No abayas found
              </h3>
              <p className="text-gray-600 mb-8 max-w-md mx-auto">
                Try adjusting your filters to discover more of our beautiful signature collection
              </p>
              <button
                onClick={() => {
                  setSelectedCategory('All');
                  setPriceRange('All');
                }}
                className="bg-gold-500 hover:bg-gold-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-md"
              >
                Clear All Filters
              </button>
            </div>
          )}
        </div>
      </section>

      {/* In-Hand Collection Callout Banner */}
      <section className="py-16 bg-gradient-to-r from-emerald-800 via-emerald-700 to-emerald-600 relative overflow-hidden">
        {/* Pattern Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center space-x-2 bg-gold-500 text-white px-4 py-2 rounded-full text-sm font-bold mb-6 shadow-lg">
              <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
              <span>In-Hand Collection</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Ready to Ship Today
            </h2>
            <p className="text-xl text-cream-100 leading-relaxed mb-8 max-w-2xl mx-auto">
              All our signature abayas are in stock and ready to ship immediately. No waiting, no delays—just pure elegance delivered to your doorstep.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <div className="flex items-center space-x-3 text-cream-100">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="ri-truck-line text-2xl text-gold-400"></i>
                </div>
                <div className="text-left">
                  <div className="font-bold text-white">Fast Shipping</div>
                  <div className="text-sm">Ships within 24 hours</div>
                </div>
              </div>
              
              <div className="hidden sm:block w-px h-12 bg-white/20"></div>
              
              <div className="flex items-center space-x-3 text-cream-100">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="ri-hand-heart-line text-2xl text-gold-400"></i>
                </div>
                <div className="text-left">
                  <div className="font-bold text-white">Handcrafted</div>
                  <div className="text-sm">With love & tradition</div>
                </div>
              </div>
              
              <div className="hidden sm:block w-px h-12 bg-white/20"></div>
              
              <div className="flex items-center space-x-3 text-cream-100">
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-gold-400"></i>
                </div>
                <div className="text-left">
                  <div className="font-bold text-white">Quality Assured</div>
                  <div className="text-sm">Premium fabrics only</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-cream-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-emerald-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Need Help Choosing?
          </h2>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto leading-relaxed">
            Our team is here to help you find the perfect abaya for any occasion. We're happy to answer questions about sizing, embroidery details, or styling.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-gold-500 hover:bg-gold-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            Contact Us Today
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ClothingPage;